import { render, staticRenderFns } from "./MyTitle.vue?vue&type=template&id=5126dee1&scoped=true&"
var script = {}
import style0 from "./MyTitle.vue?vue&type=style&index=0&id=5126dee1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5126dee1",
  null
  
)

export default component.exports